import { Injectable } from '@angular/core';
import {Location} from "@angular/common";
import {BehaviorSubject} from 'rxjs';

export function startupServiceFactory(startupService: LocalizationService): Function {
  return () => startupService.initSetUp();
}

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  constructor(private location: Location) {}
  private languageSubject = new BehaviorSubject<number>(this.getActiveLang());
  language$ = this.languageSubject.asObservable();

  codes: string[] = ["ru", "en"];


  setData(key: string, obj: any){
    const json = JSON.stringify(obj);
    localStorage.setItem(key, json);
  }

  getData(key: string){
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }

  getLocal() {
    if (!this.codes || !Array.isArray(this.codes)) {
      console.error('Codes array is not initialized');
      return 0;
    }
    const navigatorLanguages = navigator.languages
      .map(v => v.split('-')[0].toLocaleLowerCase()) || [];
    let lang: number | undefined;
    let flag = false;
    navigatorLanguages.forEach(l => {
      const index = this.codes?.findIndex(v => v == l) ?? -1;
      if (index > -1 && !flag) {
        lang = index;
        flag = true;
      }
    });
    return lang ?? 0;
  }


  setLanguage(idx?: number) {
    const index = idx ?? (this.getActiveLang() === 0 ? 1 : 0);
    this.setData('language', index);
    this.languageSubject.next(index);
  }

  getActiveLang() {
    const idx = this.getData('language');
    return idx ?? this.getLocal();
  }

  getLangCode() {
    return this.codes[this.getActiveLang()] ?? this.codes[0];
  }

  getLangCodeParams() {
    const code = this.codes[this.getActiveLang()] ?? this.codes[0];
    return code + "_" + code.toUpperCase();
  }


  initSetUp(){
    const idxLang = this.getData('language');
    this.setLanguage(this.getActiveLang());
    if (idxLang == null) {
      this.location.replaceState(this.location.path());
      window.location.reload();
    }
  }
}
